import React from 'react';
import { useCart } from '../Context/CartContext';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const { currentUser } = useCart();

  // You might want a loading spinner here while Firebase Auth is checking
  // but for now, this is the core logic.

  if (!currentUser) {
    // If user is not logged in, redirect to the home page
    return <Navigate to="/" replace />;
  }

  // If user is logged in, show the component (e.g., the MyAccountPage)
  return children;
};

export default ProtectedRoute;